export interface OrganizationDetails {
  readonly id: string; // main organization, a child organization
  readonly parentOrganizationId?: string; // an organization considered parent, and should be different as above `id`
  readonly name: string;
  readonly countryCode: string;
  readonly type: string;
  readonly status: OrganizationStatus;
  readonly createdOn: string | Date;
}

export enum OrganizationStatus {
  Active = "Active",
  Inactive = "Inactive"
}
